export default "__VITE_ASSET__BPyL3GV$__";